<template>
    <div>
        <zhaoshangdanao v-if="curWebsite.type == 1"></zhaoshangdanao>
        <chanyeyanjiu v-else-if="curWebsite.type == 6"></chanyeyanjiu>
        <chanyetouzi v-else-if="curWebsite.type == 5"></chanyetouzi>
        <zhaoshangdanao v-else></zhaoshangdanao>
    </div>
</template>

<script>
import zhaoshangdanao from './components/zhaoshangdanao.vue';
import chanyeyanjiu from './components/chanyeyanjiu.vue';
import chanyetouzi from './components/chanyetouzi.vue';

export default {
    name: 'HomePage',
    components: {
        zhaoshangdanao,
        chanyeyanjiu,
        chanyetouzi,
        
    },
    data() {
        return {
            userdata: {},
            curWebsite: this.$api.getWebsiteType(),
        };
    },

};
</script>

<style scoped>
/* Your styles go here */
</style>